import { Box } from '@dtx-company/design-system/src/components/Box/Box'
import { FC } from 'react'
import { PrintStoreContainer } from '../../containers/print-store/PrintStoreContainer'
import { PrintStoreTemplatesTopBanner } from './TopBanner/TopBanner'
import { Stack } from '@dtx-company/design-system/src/components/Stack/Stack'
import { TemplateFAQs } from './TemplateFAQs/TemplateFAQs'
import { TemplatesList } from './TemplatesList/TemplatesList'

export const PrintStoreTemplates: FC = () => {
  return (
    <PrintStoreContainer>
      <Stack>
        <PrintStoreTemplatesTopBanner />
        <Box
          sx={theme => ({
            p: { _: 0, md: theme.spacing(5, 6, 8.25), xl: theme.spacing(5, 6, 10) }
          })}
        >
          <TemplatesList />
        </Box>
        <TemplateFAQs />
      </Stack>
    </PrintStoreContainer>
  )
}
